import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { StateService } from '../../core/state/old/state.service';
import { inject } from '@angular/core';
import { DataService } from '../../core/providers/data/data.service';
import { map, of, switchMap, tap } from 'rxjs';
import { GetActiveCustomerQuery } from '../../graphql/generated/generated-types';
import { Platform } from '@angular/cdk/platform';
import { GET_CUSTOMER_NAMES } from '../components/navigation/active-customer.graphql';
import { ActiveService } from '../../core/providers/active/active.service';

export const userGuard: CanActivateFn = (route, state) => {
  const stateService = inject(StateService);
  const dataService = inject(DataService);
  const router = inject(Router);
  const platform = inject(Platform);
  const activeService = inject(ActiveService);

  return stateService
    .select((state) => state.signedIn)
    .pipe(
      switchMap((signedIn) => {
        if (signedIn) {
          return of(true);
        } else {
          if (platform.isBrowser) {
            return activeService.activeCustomer$.pipe(
              map((data) => !!data as boolean),
              tap((data) => {
                if (!data) {
                  router.navigate(['/']);
                }
              })
            );
            /*
          return dataService.query<GetActiveCustomerQuery>(GET_CUSTOMER_NAMES).pipe(
            map(data => !!data.activeCustomer as boolean),
            tap((activeCustomer) => {
              if(!activeCustomer){
                router.navigate(['/']);
              }
     
            })
          );
          */
          } else {
            return of(false);
          }
        }
      })
    );
};

export const notLoggedInChild: CanActivateChildFn = (route, state) => {
  const stateService = inject(StateService);
  const dataService = inject(DataService);
  const router = inject(Router);
  const platform = inject(Platform);

  return stateService
    .select((state) => state.signedIn)
    .pipe(
      switchMap((signedIn) => {
        if (signedIn) {
          router.navigate(['/']);
          return of(false);
        } else {
          if (platform.isBrowser) {
            return dataService
              .query<GetActiveCustomerQuery>(GET_CUSTOMER_NAMES)
              .pipe(
                map((data) => !!data.activeCustomer as boolean),
                tap((activeCustomer) => {
                  if (activeCustomer) {
                    router.navigate(['/']);
                  }
                }),
                switchMap((activeCustomer) => {
                  return of(!activeCustomer);
                })
              );
          } else {
            return of(false);
          }
        }
      })
    );
};
